import { render } from "./ResearcherGroup.vue?vue&type=template&id=18d42e5e&scoped=true"
import script from "./ResearcherGroup.vue?vue&type=script&lang=js"
export * from "./ResearcherGroup.vue?vue&type=script&lang=js"

import "./ResearcherGroup.vue?vue&type=style&index=0&id=18d42e5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d42e5e"]])

export default __exports__